import OrderEditionService from '../../services/orders/OrderEditionService';
import i18n from '../../i18n';

export default {
    data() {
        return {
            headers: [
                {
                    text: i18n.t('headers.date'),
                    sortable: false,
                    value: "date"
                },
                {
                    text: i18n.t('headers.nro-order'),
                    sortable: false,
                    value: "orderNumber"
                },
                {
                    text: i18n.t('headers.provider'),
                    sortable: false,
                    value: "provider"
                },
                {
                    text: i18n.t('headers.user'),
                    value: "user",
                    sortable: false
                },
                {
                    text: '',
                    value: "unblock",
                    sortable: false
                }
            ],
            items: [],
            pagination: {},
            totalItems: 0,
            loading: false,
            dialog: false
        }
    },

    watch: {
        pagination: {
            handler() {
                this.getBlockOrders();
            },
            deep: true
        }
    },

    methods: {
        async getBlockOrders() {
            this.loading = true;
            const { page, rowsPerPage } = this.pagination;
            try {
                const response = await OrderEditionService.getBlockedOrders(page - 1, rowsPerPage);
                if (response && response.data) {
                    this.items = response.data[0];
                    this.totalItems = response.data[1];
                }
            } catch (error) {
                this.loading = false;
            }
        },

        async unblockOrder(id) {
            try {
                const data = {
                    editing: 0
                }
                await OrderEditionService.unBlockOrder(id, data);
                this.dialog = false;
                this.$notify({
                    group: "app",
                    type: "success",
                    text: i18n.t('unblock-order.order-succesfully-unblocked')
                });
                await this.getBlockOrders();
            } catch (error) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t('unblock-order.error-ocurred-unblocking-order')
                });
            }
        }
    }
}